import { client } from '@/client';

export function getInspectList(params) {
  return client.post('/api/sys_pulsar_inspection_rules_service/page-query', params);
}

export function deleteInspect(id) {
  return client.delete(`/api/sys_pulsar_inspection_rules_service/delete/${id}`);
}

export function addInspect(params) {
  return client.post('/api/sys_pulsar_inspection_rules_service/create', params);
}

export function updateInspect(params) {
  return client.post('/api/sys_pulsar_inspection_rules_service/update', params);
}
